/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import DefMembershipActions from "../../Redux/actions/defMembership-actions";
import Customer from "./customers";
import "../../Styles/pages/customers.scss";
import "../../Styles/pages/dashboard.scss";
import BusinessCustomersActions from "../../Redux/transition/customers/business-customer.reducer.js";
import { TAG_GROUP_DROPDOWN_PAGE_OPTIONS } from "./Segments/tagUtils";

const CustomersIndex = () => {
    const defMembership = useSelector((state) => state.defMembership.defMembership);

    const dispatch = useDispatch();
    const getMembership = useCallback(() => { dispatch(DefMembershipActions.defMembershipRequest()) }, [dispatch]);
    const getTagGroups = useCallback(
        (businessId) =>
            dispatch(
                BusinessCustomersActions.tagGroupRequest(
                    businessId,
                    TAG_GROUP_DROPDOWN_PAGE_OPTIONS
                )
            ),
        [dispatch]
    );
    const getTags = useCallback((businessId) => dispatch(BusinessCustomersActions.tagsRequest(businessId)), [dispatch]);

    useEffect(() => {
        if (!defMembership) {
            getMembership();
            return;
        }
        getTagGroups(defMembership.business.id);
        getTags(defMembership.business.id);
    }, [defMembership, getMembership, getTagGroups, getTags]);

    return (
        <div className="customerContent">
            <Customer />
        </div >
    )
}

export default CustomersIndex;
